// extracted by mini-css-extract-plugin
export default {"Contacts":"Contacts_Contacts__BVnR4","swing-in":"Contacts_swing-in__35lZX"};